import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  private verticalPosition: MatSnackBarVerticalPosition = 'bottom';

  constructor(private _snackBar: MatSnackBar) {}

  /** Display success message
   * @param message Message text
   */
  public success(message: string) {
    this._snackBar.open(`${message}`, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: 'success-notification',
    });
  }

  /** Display error message
   * @param message Message text
   */
  public error(message: string) {
    this._snackBar.open(`${message}`, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: 'error-notification',
    });
  }

  /** Display warning message
   * @param message Message text
   */
  public warning(message: string) {
    this._snackBar.open(`${message}`, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: 'warning-notification',
    });
  }
}
